import { render, staticRenderFns } from "./algo-task-first.html?vue&type=template&id=a233d8de&scoped=true&external"
import script from "./algo-task-first.js?vue&type=script&lang=js&external"
export * from "./algo-task-first.js?vue&type=script&lang=js&external"
import style0 from "./algo-task-first.scss?vue&type=style&index=0&id=a233d8de&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a233d8de",
  null
  
)

export default component.exports